import axios from 'axios';

const DEFAULT_PORTAL_BASE_URL = 'http://ecomsquare.onebitconsult.com/';

const resolveBaseUrl = () => {
  const configuredBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_BASE_URL_DEV ||
    process.env.REACT_APP_BASE_URL ||
    process.env.REACT_APP_API_ENDPOINT ||
    DEFAULT_PORTAL_BASE_URL;

  const trimmed = configuredBase.trim().replace(/^['"]|['"]$/g, '');
  const baseWithoutTrailingSlash = trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;

  if (/\/api$/i.test(baseWithoutTrailingSlash)) {
    return baseWithoutTrailingSlash;
  }

  return `${baseWithoutTrailingSlash}/api`;
};

export const apiClient = axios.create({
  baseURL: resolveBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const requestConfig = { ...config };
  const token = window.localStorage.getItem('access_token') || window.localStorage.getItem('b2b-jwtToken');

  if (token) {
    requestConfig.headers = {
      ...requestConfig.headers,
      Authorization: `Bearer ${token}`,
    };
  }

  return requestConfig;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error?.response ?? error),
);

export default apiClient;
